module.exports = __webpack_public_path__ + "static/media/turkmenistan.41a8283f.png";